window.addEventListener('load', () => {
  if(document.getElementById('alma-badge')) {
    document.getElementById('alma-badge').style.display = "block";
  }
  // document.getElementById('checkout').disabled = true;
  document.getElementById('checkout').style.display = "inline-flex";
  
  // document.getElementById('policy').addEventListener('change', () => {
  //   if(document.getElementById('policy').checked) {
  //     document.getElementById('checkout').disabled = false;
  //     document.getElementById('dynamic-checkout-cart').classList.add('active');
  //   }
  //   else {
  //     document.getElementById('checkout').disabled = true;
  //     document.getElementById('dynamic-checkout-cart').classList.remove('active');
  //   }
  // });
});